import './fd-kit.css';
import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router';

import { AuthProvider } from './AuthContext.tsx';
import { Layout } from './components/Layout.tsx';
import { PrivateRoute } from './components/PrivateRoute.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { DevicesPage } from './pages/DevicesPage.tsx';
import { DeviceDetailPage } from './pages/DeviceDetailPage.tsx';
import { SessionsPage } from './pages/SessionsPage.tsx';
import { SessionDetailPage } from './pages/SessionDetailPage.tsx';
import { DecisionsPage } from './pages/DecisionsPage.tsx';
import { KpisPage } from './pages/KpisPage.tsx';
import { RulesPage } from './pages/RulesPage.tsx';
import { WebhooksPage } from './pages/WebhooksPage.tsx';

const apiBase = import.meta.env.VITE_API_BASE || '/v1/console';

function App() {
  return (
    <AuthProvider apiBase={apiBase}>
      {/* basename: the app is served under vite's `base` ('/console/'); without
          it the router matches nothing at /console/* and renders a blank page. */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<KpisPage />} />
            <Route path="devices" element={<DevicesPage />} />
            <Route path="devices/:alias" element={<DeviceDetailPage />} />
            <Route path="sessions" element={<SessionsPage />} />
            <Route path="sessions/:id" element={<SessionDetailPage />} />
            <Route path="decisions" element={<DecisionsPage />} />
            <Route path="rules" element={<RulesPage />} />
            <Route path="webhooks" element={<WebhooksPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
